import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div<{ $isShow: boolean }>`
	width: 40vw;
	max-width: 500px;
	height: 100%;
	display: ${(props) => (props.$isShow ? 'flex' : 'none')};
	flex-direction: column;
	gap: 1.5rem;
	align-items: flex-start;
	justify-content: center;

	@media (max-width: 700px) {
		width: 50vw;
		max-width: 50vw;
	}
`;

export const listProducts = styled.div`
	width: 100%;
	height: 30vh;
	max-height: 400px;
	overflow: auto;
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	align-items: flex-start;
	justify-content: flex-start;
`;

export const product = styled.div`
	width: 100%;
	cursor: pointer;
	display: flex;
	gap: 1rem;
	align-items: center;
	justify-content: flex-start;
	border-radius: 5px;
	border: 1px solid ${color.interface.lightGray2};
	padding: 1rem;
	background-color: ${color.interface.white};
	transition: all ease 0.1s;

	> img {
		width: 50px;
		height: 50px;
		border-radius: 5px;
		object-fit: initial;
	}

	> p {
		color: ${color.interface.lightGray};
		font-size: 1.4rem;
	}
`;

export const content = styled.div`
	width: 100%;
	display: flex;
	align-items: flex-start;
	justify-content: center;
	flex-direction: column;
	gap: 0.2rem;

	p,
	b {
		font-size: 1.3rem;
		color: ${color.interface.darkgray};
	}
`;

export const actions = styled.div`
	position: absolute;
	top: 1rem;
	right: 1rem;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: row;
	gap: 1rem;

	> svg {
		cursor: pointer;
		font-size: 2.2rem;
	}
`;

export const noProduct = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	gap: 1.5rem;
	align-items: center;
	justify-content: center;

	> p {
		color: ${color.interface.lightGray};
		font-weight: 900;
		font-size: 1.5rem;
	}
`;
